<template>
  <bg-style v-if="enabled" v-imloading="loading" :is-disabled="$store.getters.isStandAloneMode" :bg="model.background"
    :mobile-bg="model.mobileBackground" :style="{ ...getTextColor(model.moduleColor, true), ...lotteryStyle }"
    class="lottery-widget" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <rich-text v-if="model.titleVisible" v-model="model.title" :stroke.sync="model.titleStroke" :editing="editing"
        class="w-full relative title" theme="snow" :disabled="!editing" />
      <rich-text v-if="model.subtitleVisible" v-model="model.subtitle" :stroke.sync="model.subTitleStroke"
        :editing="editing" class="mt-3 describe relative" theme="snow" :disabled="!editing" />
      <div v-if="!isTicketMode" class="w-full flex items-center mx-auto max-w-[800px] mt-10 justify-between px-[5px] relative">
        <div class="text-14 flex items-center">
          <span v-if="activityRule.lottery_type === 2">{{ activityRule.fiat_currency.country_currency }}</span>
          <div class="flex items-center">
            <img v-if="lotteryDetail.virtual_currency_logo" class="w-[30px] h-[30px]"
              :src="lotteryDetail.virtual_currency_logo" alt="" />
            <span class="ml-2">{{ lotteryDetail.virtual_currency_name }}</span>
          </div>
          <span class="text-success-6">{{ currentValue === -1 ? $t('siteBuild.limitReach') : currentValue }}</span> /
          <span>{{ totalValue }}</span>
        </div>
        <div v-if="time" class="text-14 flex items-center">
          <i class="el-icon-timer text-18" />
          <span class="ml-2">{{ time }}</span>
        </div>
      </div>
      <div v-if="isTicketMode && time" class="w-full flex items-center justify-end mx-auto max-w-[800px] mt-8 px-[5px] relative">
        <div class="text-14 flex items-center">
          <i class="el-icon-timer text-18" />
          <span class="ml-2">{{ time }}</span>
        </div>
      </div>
      <div class="lottery-widget__content mt-5">
        <bg-style class="lottery-widget__pan" :radius="2000" :bg="model.panBackground">
          <div class="inner-border" :style="{ borderColor: model.circleBackground.backgroundColor }" />
          <bg-style class="inner-circle" :bg="model.blockBackground" :radius="999" />
          <bg-style :bg="model.giftBackground" class="inner-block" :class="{ 'transition-none': isSkip && !rotating }"
            :radius="999" :style="panStyle">
            <template v-if="list.length && list[0].angle">
              <div v-for="(item, index) in list" :key="`${index}-${item.id}`" class="bg-item" :style="item.bgStyle">
                <div class="circle-flag" :style="{ transform: `skewY(${item.bgStyle.skewYDeg}deg)` }" />
              </div>
              <div v-for="(item) in list" :key="item.id" class="item" :style="item.style">
                <div class="chance text-12" :class="{ 'invisible': !model.weightVisible }">
                  <span>{{ item.weight }}%</span>
                </div>
                <div class="pic flex-col flex items-center justify-center" :class="{ 'has-level': !!item.level_icon }"
                  :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
                  <img :src="item.gift_goods_logo" alt="" class="cursor-pointer"
                    @click.stop="handleShowPrizeDetail(item)">
                </div>
                <div v-if="item.num" class="flex items-center justify-center text-12 gap-1 number">
                  <i class="el-icon-close font-bold" />
                  <span>{{ item.num }}</span>
                </div>
              </div>
            </template>
          </bg-style>
        </bg-style>
        <div class="pointer flex items-center justify-center" :style="pointerStyle"
          :class="{ disabled: actionsDisabled }" @click="lottery">
          <div class="pointer-bg flex items-center justify-center">
            <bg-style class="go" :bg="model.axleBackground" :radius="100"
              :style="{ border: `2px solid ${model.axleBorderColor}` }">
              <span class="relative"
                :style="{ '-webkit-text-stroke': `2px ${model.goBorderColor}`, ...getTextColor(model.goColor, true) }">GO</span>
            </bg-style>
          </div>
        </div>
      </div>
      <div
        class="lottery-widget__tools text-center max-w-[600px] relative mx-auto mt-8 flex items-center justify-between flex-wrap">
        <div class="flex items-center icon-tool w-1/3">
          <im-icon class="text-20 mr-5 cursor-pointer" icon="icon-help" @click.native="handleShowRule" />
          <i class="el-icon-tickets text-20 cursor-pointer" @click="handleShowHistory" />
        </div>
        <span class="remain-tip w-1/3 flex items-center justify-center" :style="getTextColor(model.moduleColor, true)">
          <img v-if="isTicketMode && ticketIcon" :src="ticketIcon" class="ticket-icon" alt="" />
          <template v-if="!isTicketMode">{{ $t('siteBuild.lotteryWidget.count') }}：{{ remainTimes }}</template>
          <template v-else>
            <span :class="{ underline: ticketCountClickable, 'cursor-pointer': ticketCountClickable }" @click="handleShowTicketDetail">{{ ticketCountDisplay }}</span>
          </template>
          <img v-if="isTicketMode && model.ticketBuyIcon.backgroundImage" :src="model.ticketBuyIcon.backgroundImage"
            class="buy-ticket-icon" @click="handleOpenTicketDialog" alt="" />
          <i v-else-if="isTicketMode" class="el-icon-plus buy-ticket-icon" @click="handleOpenTicketDialog" />
        </span>
        <div class="w-1/3 flex justify-end">
          <el-checkbox v-model="isSkip" class="skip">{{ $t('siteBuild.lotteryWidget.skipAnimation') }}</el-checkbox>
        </div>
      </div>
      <div class="lottery-widget__actions relative">
        <button class="action-btn" :disabled="actionsDisabled" @click="lottery">
          <i v-if="oneLoading" class="el-icon-loading"></i>
          <span>{{ oneLoading ? $t('siteBuild.lotteryWidget.drawing') : $t('siteBuild.lotteryWidget.singleDraw')
          }}</span>
        </button>
        <button class="action-btn" :disabled="actionsDisabled" @click="handleTenDraw">
          <i v-if="tenLoading" class="el-icon-loading"></i>
          <span>{{ tenLoading ? $t('siteBuild.lotteryWidget.drawing') : $t('siteBuild.lotteryWidget.tenDraw') }}</span>
        </button>
      </div>
      <div v-if="giftList && giftList.length" class="lottery-widget__gifts mt-8 relative"
        :style="{ '--progress-background': model.progressBackground.backgroundColor }">
        <div class="mb-5 gifts-title">
          <span class="text-18 text-bold">{{ $t('siteBuild.lotteryWidget.consecutive') }}:</span>
          <span v-if="isLoop" class="text-18 text-bold ml-2">{{ $t('siteBuild.lotteryWidget.cycleTip', {
            number:
              countCycle
          })
            }}</span>
        </div>
        <div class="flex justify-center w-full">
          <div ref="giftList" class="gift-list">
            <div class="inner-percent"
              :style="{ background: model.innerBackground.backgroundColor, width: progressWidth + 'px' }" />
            <div v-for="(item, index) in giftList" :key="index" class="item flex items-center justify-center flex-col"
              :class="{ 'active': item.active, [`item-${item.times_no}`]: true }">
              <div class="pic">
                <img :src="item.gift_goods_logo" class="w-full relative z-10 cursor-pointer" alt="goods"
                  @click="handleGiftClick(item)">
                <span v-if="item.num" class="num-badge">{{ item.num }}</span>
                <bg-style v-if="(index === 1 && editing) || item.get_status === 2" class="w-full h-full get"
                  :bg="model.getBackground" />
                <bg-style v-if="(index === 0 && editing) || item.get_status === 1" class="w-full h-full received z-20"
                  :bg="model.receivedBackground" />
                <div v-if="getLoading && claimingItemIndex === index" class="w-full h-full get-loading z-30">
                  <i class="el-icon-loading" />
                </div>
              </div>
              <div class="index mt-10">{{ item.times_no }}</div>
              <div class="line" :style="{ background: model.progressBackground.backgroundColor }" />
            </div>
          </div>
        </div>
      </div>
    </module-block>
    <history-dialog ref="history" :editing="editing" :model="model" />
    <rule-dialog ref="rule" :editing="editing" :model="model" />
    <confirm-dialog :visible.sync="confirmVisible" :title="confirmTitle" :message="confirmMessage"
      :confirm-text="$t('siteBuild.confirm')" :cancel-text="$t('siteBuild.cancel')" @confirm="onConfirmTen"
      @cancel="onCancelConfirm" />
    <el-dialog class="gift-dialog dialog-base" :class="{ 'is-mobile': $store.getters.isMobile }"
      :width="$store.getters.isMobile ? '80%' : '520px'" :show-close="false" :visible.sync="visible">
      <div class="gift-dialog__content">
        <div class="title">{{ resultGifts.length <= 1 ? (isHit ? model.successTitle : model.fallTitle) :
          $t('siteBuild.lotteryWidget.resultTitle') }}</div>
            <div v-if="resultGifts.length <= 1" class="flex items-center justify-center mt-8">
              <div v-if="isHit" class="result-card single" :class="{ 'has-level': !!currentPrize.level_icon }"
                :style="currentPrize.level_icon ? { '--level-bg': `url('${currentPrize.level_icon}')` } : null">
                <img :src="currentPrize.gift_goods_logo" alt="">
                <div class="numbar"><span>{{ currentPrize.num }}</span></div>
              </div>
              <div v-else class="result-card single miss-card">
                <img :src="currentPrize.gift_goods_logo" alt="">
              </div>
            </div>
            <div v-else class="result-list-wapper">
              <div v-scroll-shadow class="result-list">
                <div v-for="(g, i) in resultGifts" :key="i" class="result-row">
                  <div class="index-label">{{ $t('siteBuild.lotteryWidget.timesIndex', { number: i + 1 }) }}</div>
                  <div class="result-content">
                    <div v-if="!['-1', -1].includes(g.gift_goods_id)" class="result-card"
                      :class="{ 'has-level': !!g.level_icon }"
                      :style="g.level_icon ? { '--level-bg': `url('${g.level_icon}')` } : null">
                      <img :src="g.gift_goods_logo" alt="">
                      <div class="numbar"><span>{{ g.num }}</span></div>
                    </div>
                    <div v-else class="miss">{{ $t('siteBuild.lotteryWidget.missTip') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="close-btn" @click="handleCloseDialog">{{ $t('siteBuild.confirm') }}</div>
        </div>
    </el-dialog>
    <ticket-dialog :visible.sync="ticketDialogVisible" :product-list="productList"
      :module-color="model.moduleColor" :axel-background="model.axleBackground" :go-color="model.goColor"
      :card-background="model.cardBackground" :editing="editing" :loading="ticketLoading"
      :buy-loading.sync="ticketBuyLoading"
      :title.sync="model.ticketDialogTitle"
      @buy="handleBuyTicket" />
    <el-dialog class="ticket-detail-dialog dialog-base" :class="{ 'is-mobile': $store.getters.isMobile }"
      :width="$store.getters.isMobile ? '90%' : '400px'" :visible.sync="ticketDetailVisible">
      <div slot="title" class="ticket-detail-dialog__header">
        <span class="ticket-detail-dialog__header-title">{{ $t('siteBuild.lotteryWidget.ticketDetail') }}</span>
      </div>
      <div class="ticket-detail-dialog__body">
        <div class="ticket-detail-dialog__icon">
          <img v-if="ticketIcon" :src="ticketIcon" alt="" />
          <i v-else class="el-icon-tickets" />
        </div>
        <div class="ticket-detail-dialog__lines">
          <div v-for="(line, i) in ticketDetailLines" :key="i"
            :class="{ 'warning': line.warning }" class="ticket-detail-dialog__line">
            {{ line.text }}
          </div>
        </div>
        <button class="ticket-detail-dialog__btn" @click="ticketDetailVisible = false">
          {{ $t('siteBuild.confirm') }}
        </button>
      </div>
    </el-dialog>
    <desk-pay-modal v-if="deskPay.visible" :desk-pay="deskPay" :lang-id-data="$store.state.locale.langIdData"
      @close="closePayModal" />
    <reward-info-dialog ref="prizeDetail" :data="currentPrizeDetail" :is-mobile="$store.getters.isMobile" />
  </bg-style>
</template>

<script>
import { Dialog, Message, Empty } from 'element-ui'
import { mapState } from 'vuex'
import { isNil, cloneDeep } from 'lodash-es'
import dayjs from 'dayjs'
import scrollShadow from '../common/scrollShadow'
import ConfirmDialog from '../common/ConfirmDialog.vue'
import RuleDialog from './rule.vue'
import TicketDialog from './TicketDialog.vue'
import HistoryDialog from './history.vue'
import RichText from '~/components/richText/index.vue'
import { formatZoneTime, getLangIdI18n, getTextColor, sleep, generateOrderParams, generatePayUrl, checkIgnoreMessage } from '~/utils'
import { DeviceEnum } from '~/enums/deviceEnum'
import { ForeverTimeValue } from '~/enums/date'
import ImIcon from '~/components/common/ImIcon.vue'
import Bus from '~/site/model/bus'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import RewardInfoDialog from '~/components/common/RewardInfoDialog.vue'
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import { BusEventMap } from '~/enums/data'

export default {
  name: 'LotteryWidget',
  components: {
    ModuleBlock,
    ImIcon,
    RichText,
    HistoryDialog,
    RuleDialog,
    ConfirmDialog,
    RewardInfoDialog,
    DeskPayModal,
    TicketDialog,
    [Dialog.name]: Dialog,
    [Empty.name]: Empty,
  },
  directives: {
    scrollShadow
  },
  props: {
    device: {
      type: String,
      default: DeviceEnum.MOBILE
    },
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      oneLoading: false,
      getLoading: false,
      claimingItemIndex: -1,
      loading: false,
      isSkip: false,
      progressWidth: '',
      DeviceEnum,
      activityRule: {
        fiat_currency: {}
      },
      resultGifts: [],
      enabled: false,
      countCycle: 0,
      isLoop: false,
      stopTime: 0,
      visible: false,
      singleLoading: false,
      tenLoading: false,
      confirmVisible: false,
      confirmTitle: '',
      confirmMessage: '',
      confirmTimes: 0,
      currentValue: 0,
      totalValue: 0,
      time: 0,
      giftList: [],
      prize: '',
      rotateDeg: 0,
      list: [],
      noData: false,
      remainTimes: 0,
      lotteryDetail: {
        consumed_counting_times: 0,
        virtual_currency_logo: '',
        virtual_currency_name: '',
        has_lottery_times: 0,
        count_lottery_max_times: 0
      },
      isHit: false,
      panStyle: {
        transform: 'rotate(0)'
      },
      rotating: false,
      currentPrizeDetail: {},
      ticketIcon: '',
      productList: [],
      ticketDialogVisible: false,
      ticketLoading: false,
      ticketBuyLoading: false,
      ticketDetailVisible: false,
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      },
      resolvedActivityId: null
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo,
      projectId: (state) => state.project.projectId,
    }),
    lotteryStyle() {
      return {
        '--weight-background': this.model.blockBackground.backgroundColor,
        '--inner-background': this.model.innerBackground.backgroundColor,
        '--gift-background': getTextColor(this.model.giftBackground).color,
        '--go-background': getTextColor(this.model.axleBackground).color,
        '--go-color': this.model.goColor,
        '--module-color': this.model.moduleColor
      }
    },
    bizId() {
      return this.model.bizId
    },
    chainId() {
      return this.model.chainId
    },
    currentPrize() {
      return this.list.find(item => item.gift_no === this.prize) || {}
    },
    pointerStyle() {
      const model = this.model
      return {
        '--arrow-color': model.arrowBackground.backgroundColorShow ? model.arrowBackground.backgroundColor : 'unset',
        background: model.drawBackground.backgroundColor,
        border: `2px solid ${model.drawBorderColor}`
      }
    },
    isTicketMode() {
      return this.activityRule.lottery_type === 3
    },
    ticketCountDisplay() {
      const purchased = this.lotteryDetail.purchased_balance || 0
      const gift = this.lotteryDetail.gift_balance || 0
      if (purchased === 0 && gift === 0) return '0'
      if (purchased > 0 && gift === 0) return String(purchased)
      if (purchased === 0 && gift > 0) return String(gift)
      return `${purchased}+${gift}`
    },
    ticketCountClickable() {
      const purchased = this.lotteryDetail.purchased_balance || 0
      const gift = this.lotteryDetail.gift_balance || 0
      return purchased > 0 || gift > 0
    },
    ticketDetailLines() {
      const purchased = this.lotteryDetail.purchased_balance || 0
      const gift = this.lotteryDetail.gift_balance || 0
      const lines = []
      if (purchased > 0) {
        lines.push({ text: this.$t('siteBuild.lotteryWidget.purchasedTickets', { number: purchased }), warning: false })
      }
      if (gift > 0) {
        lines.push({ text: this.$t('siteBuild.lotteryWidget.giftTickets', { number: gift }), warning: false })
      }
      if (gift > 0) {
        lines.push({ text: this.$t('siteBuild.lotteryWidget.giftTicketsWarning'), warning: true })
      }
      return lines
    },
    actionsDisabled() {
      return this.rotating || this.oneLoading || this.tenLoading
    },
    countdownVisible() {
      return !(!this.stopTime || this.stopTime === ForeverTimeValue)
    }
  },
  watch: {
    bizId(n, o) {
      if (n !== o) {
        this.init()
      }
    },
    chainId(n, o) {
      if (n !== o) {
        this.resolvedActivityId = null
        this.init()
      }
    },
    device() {
      this.generateProgress()
    }
  },
  beforeDestroy() {
    Bus.$off('reloadActivity')
    Bus.$off(BusEventMap.RefreshLottery, this.delayedInit)
    clearTimeout(this._refreshTimer)
  },
  mounted() {
    Bus.$on('reloadActivity', (type) => {
      if (type === 'payment') {
        this.getLotteryDetail()
      } else {
        this.init()
      }
    })
    Bus.$on(BusEventMap.RefreshLottery, this.delayedInit)
    this.init()
  },
  methods: {
    delayedInit() {
      clearTimeout(this._refreshTimer)
      this._refreshTimer = setTimeout(() => {
        this.init()
      }, 1000)
    },
    handleShowPrizeDetail(item) {
      if (this.rotating || this.editing) return
      if (['-1', -1].includes(item.gift_goods_id)) return
      this.currentPrizeDetail = {
        gift_list: [{
          gift_goods_logo: item.gift_goods_logo,
          gift_goods_name: item.gift_goods_name,
          num: item.num,
          level_icon: item.level_icon
        }]
      }
      this.$nextTick(() => {
        this.$refs.prizeDetail.init()
      })
    },
    async handleOpenTicketDialog() {
      if (!this.checkStatus() && !this.editing) {
        return this.showLogin()
      }
      this.ticketBuyLoading = false
      this.ticketDialogVisible = true
      if (!this.editing) {
        this.ticketLoading = true
        this.productList = []
        const activityId = await this.resolveChainActivityId()
        const [err, res] = await this.$utils.to(this.$api.activity.getLotteryProducts({
          activity_id: activityId
        }))
        this.ticketLoading = false
        if (!err) {
          const currency = this.$store.state.user?.ipInfo?.currency
          this.productList = (res || []).map(product => {
            if (product.item_contents2?.length && currency) {
              product = { ...product }
              product.item_contents2 = product.item_contents2.reduce((total, item) => {
                item = { ...item, num: item?.num_by_currency?.[currency] }
                if (item.num) total.push(item)
                return total
              }, [])
            }
            return product
          })
        }
      } else if (!this.productList.length) {
        this.productList = cloneDeep(this.model.__mockProductList)
      }
    },
    handleShowTicketDetail() {
      if (!this.ticketCountClickable) return
      this.ticketDetailVisible = true
    },
    async handleBuyTicket(goods) {
      const [err, res] = await this.$utils.to(generateOrderParams(this, goods))
      if (!err) {
        this.ticketDialogVisible = false
        generatePayUrl(res, this)
        this.$utils.emitRefreshProjectVip()
        await this.getLotteryDetail()
      } else {
        this.ticketBuyLoading = false
        !checkIgnoreMessage(err) && Message.error(err)
      }
    },
    closePayModal() {
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      Bus.$emit('reloadActivity', BusEventMap.Payment)
    },
    checkStatus() {
      let result = true
      if (isNil(this.userInfo?.id)) {
        result = false
      }
      return result
    },
    handleGiftClick(item) {
      if (this.editing || this.rotating) return
      if (item.get_status === 2) {
        this.handleGetPrize(item)
      } else {
        this.currentPrizeDetail = {
          gift_list: [{
            gift_goods_logo: item.gift_goods_logo,
            gift_goods_name: item.gift_goods_name,
            num: item.num,
            level_icon: item.level_icon
          }]
        }
        this.$nextTick(() => {
          this.$refs.prizeDetail.init()
        })
      }
    },
    async handleGetPrize(item) {
      if (this.editing || this.getLoading) return
      if (!this.checkStatus()) {
        return this.showLogin()
      }
      this.getLoading = true
      this.claimingItemIndex = this.giftList.findIndex(g => g.times_no === item.times_no)
      const activityId = await this.resolveChainActivityId()
      const params = {
        activity_id: activityId,
        times_no: item.times_no
      }
      const [err] = await this.$utils.to(this.$api.activity.getPrize(params))
      this.getLoading = false
      this.claimingItemIndex = -1
      if (!err) {
        Message.success('Success')
        await this.getLotteryDetail()
      } else {
        Message.error(err)
      }
    },
    showLogin() {
      this.$store.commit('user/SET_LOGINSHOW', !this.editing)
      this.$store.commit('user/SET_SITE_BIND_USER', true)
    },
    async resolveChainActivityId() {
      if (!this.chainId) {
        return this.bizId
      }
      if (this.resolvedActivityId) {
        return this.resolvedActivityId
      }
      const params = {
        project_id: this.projectId || this.userInfo.project_id || '',
        chain_id: this.chainId
      }
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList(params))
      if (!err && res?.list?.[0]?.biz_id) {
        this.resolvedActivityId = res.list[0].biz_id
      }
      return this.resolvedActivityId
    },
    getGiftItemActive(index) {
      return index <= 1
    },
    async getLotteryDetail() {
      if (this.noData || (!this.bizId && !this.chainId)) {
        this.activityUnusual()
        return
      }
      const activityId = await this.resolveChainActivityId()
      if (!activityId) {
        this.activityUnusual()
        return
      }
      const params = {
        activity_id: activityId,
        project_id: this.projectId
      }
      const [err, res] = await this.$utils.to(this.$api.activity.queryLotteryDetail(params))
      if (!err) {
        const countList = res.count_lottery_list || []
        this.countCycle = res.counting_cycle
        this.giftList = countList.map((item, index) => {
          const newItem = { ...item }
          newItem.active = this.editing ? this.getGiftItemActive(index) : [1, 2].includes(item.get_status)
          if (!newItem.gift_goods_name || !newItem.level_icon) {
            const lotteryItem = (res?.lottery_list || []).find(l => String(l.gift_goods_id) === String(newItem.gift_goods_id))
            if (lotteryItem) {
              if (!newItem.gift_goods_name) newItem.gift_goods_name = lotteryItem.gift_goods_name
              if (!newItem.level_icon) newItem.level_icon = lotteryItem.level_icon
            }
          }
          return newItem
        })
        this.list = (res?.lottery_list || []).map(item => {
          const newItem = { ...item }
          newItem.bgStyle = {}
          newItem.style = {}
          newItem.angle = 0
          return newItem
        })
        this.enabled = this.editing ? true : !!res.lottery_list?.length
        this.model.__hide = !this.enabled
        this.lotteryDetail = res
        this.lotteryDetail.has_lottery_times = this.editing ? (this.giftList?.[1]?.times_no || 0) : res.has_lottery_times
        this.lotteryDetail.virtual_currency_name = getLangIdI18n({ lang_id: res.virtual_currency_name }, this.$store.state.locale.langIdData)
        this.remainTimes = this.isTicketMode ? (res.ticket_balance || 0) : res.remain_lottery_times
        this.currentValue = res.current_lottery_amount
        this.totalValue = res.target_lottery_amount
        if (this.isTicketMode && res.counting_stop_time) {
          this.stopTime = res.counting_stop_time
          this.setTime()
        }
        // console.log(this.list, 'lotteryDetail')
        await this.$nextTick()
        await this.generateProgress()
        this.generatePrizes()
      } else {
        Message.error(err)
      }
    },
    async generateProgress() {
      this.progressWidth = 0
      if (this.lotteryDetail.has_lottery_times === 0) {
        return
      }
      const getMaxNearNumber = (arr, num) => {
        let index
        let number
        let activeIndex = null
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] <= num) {
            activeIndex = i
          }
          if (num < arr[i]) {
            number = arr[i]
            index = i
            break;
          }
        }
        return {
          number: number || arr[arr.length - 1],
          index: index || arr.length - 1,
          activeIndex
        }
      }
      const numbers = this.giftList.map(item => item.times_no)
      const hasTimes = this.lotteryDetail.has_lottery_times - this.lotteryDetail.consumed_counting_times
      await sleep(500)
      const $item = this.$refs?.giftList?.querySelector('.item')
      if (!$item) return
      const halfWidth = $item.offsetWidth / 2
      const currentIndex = this.giftList.findIndex(item => item.times_no === hasTimes)
      if (currentIndex > -1) {
        this.progressWidth = $item.offsetWidth * (currentIndex + 1) - halfWidth
      } else {
        const near = getMaxNearNumber(numbers, hasTimes)
        const gapNumber = hasTimes - numbers[near.activeIndex]
        const overGapNumber = near.number - numbers[near.activeIndex]
        const percent = near.activeIndex !== null ? (gapNumber / overGapNumber) : (hasTimes / near.number)
        const totalWidth = $item.offsetWidth * this.giftList.length - halfWidth
        const baseWidth = near.activeIndex != null ? (near.activeIndex + 1) * $item.offsetWidth - halfWidth : 0
        const overWidth = near.activeIndex !== null ? ($item.offsetWidth * percent) : (halfWidth * percent)
        const currentWidth = overWidth + baseWidth
        this.progressWidth = currentWidth > totalWidth ? totalWidth : currentWidth
      }
    },
    getTextColor,
    setTime() {
      if (!this.countdownVisible) {
        this.time = ''
        return
      }
      const now = dayjs().valueOf()
      const end = formatZoneTime(this.stopTime * 1000).value
      const leftTime = end - now;
      let d = 0; let h = 0; let m = 0; let s = 0;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        m = Math.floor(leftTime / 1000 / 60 % 60)
        s = Math.floor(leftTime / 1000 % 60)
      }
      this.time = `${d > 0 ? `${d}d:` : ''}${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}:${s < 10 ? `0${s}` : s}`
      if (leftTime > 0) setTimeout(this.setTime, 1000)
    },
    activityUnusual() {
      if (this.editing) {
        this.enabled = true
        this.activityRule = {
          lottery_type: 2,
          fiat_currency: {
            country_currency: 'USD'
          }
        }
        this.currentValue = 60
        this.totalValue = 100
        this.list = cloneDeep(this.model.__mockData)
        this.giftList = cloneDeep(this.model.__mockGiftList)
        this.lotteryDetail.has_lottery_times = 2
        this.lotteryDetail.count_lottery_max_times = 10
        this.generateProgress()
      } else {
        this.enabled = false
        this.model.__hide = true
      }
    },
    async getActivityDetail() {
      if (!this.bizId && !this.chainId) {
        this.activityUnusual()
        return
      }
      const activityId = await this.resolveChainActivityId()
      if (!activityId) {
        this.activityUnusual()
        return
      }
      const params = {
        biz_id: activityId
      }
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList(params))
      if (!err) {
        const data = res?.list || []
        const noOpen = !this.editing && data?.[0]?.status !== 2
        if (!data.length || noOpen) {
          this.enabled = false
          this.noData = true
          this.model.__hide = true
          return
        }
        // this.enabled = true
        const rule = JSON.parse(data[0].activity_rule)
        this.activityRule = rule
        this.ticketIcon = rule.ticket_icon || ''
        this.isLoop = rule.is_counting_cyclic
        this.stopTime = data[0].stop_time
        this.setTime()
        this.list = rule.lottery_list.map(item => {
          const newItem = { ...item }
          newItem.bgStyle = {}
          newItem.style = {}
          newItem.angle = 0
          return newItem
        })
        if (rule.lottery_type === 2) {
          this.totalValue = rule.fiat_currency.amount
        } else {
          this.totalValue = rule.virtual_currency.num
        }
        this.giftList = rule.count_lottery_list
      } else {
        Message.error(err)
      }
    },
    async init() {
      try {
        this.loading = true
        await this.getActivityDetail()
        this.loading = false
        await this.getLotteryDetail()
      } finally {
        this.$widgetReady()
      }
    },
    handleCloseDialog() {
      this.visible = false
    },
    handleShowRule() {
      this.$refs.rule.init()
    },
    handleShowHistory() {
      if (this.editing) return
      if (!this.checkStatus() && !this.editing) {
        return this.showLogin()
      }
      this.$refs.history.init()
    },
    async lottery() {
      if (!this.checkStatus()) {
        return this.showLogin()
      }
      const drawTimes = this.isTicketMode ? (this.lotteryDetail.remain_lottery_times || 0) : this.remainTimes
      if (drawTimes <= 0) {
        return Message.error(this.$t('siteBuild.lotteryWidget.noTimes'))
      }
      if (this.rotating) return
      this.oneLoading = true
      const [err, res] = await this.doDraw()
      this.oneLoading = false
      if (!err && res) {
        this.prize = res.gift_no
        this.$utils.emitRefreshProjectVip()
        this.resultGifts = []
      } else if (err) {
        Message.error(err)
      }
      if (err) return
      this.oneLoading = true
      this.rotation(() => {
        this.oneLoading = false
        this.showResult()
      })
    },
    rotation(callback) {
      const CIRCLE_ANGLE = 360
      const config = {
        duration: 5500,
        circle: 8
      }
      this.rotating = true
      const prize = this.list.find(item => item.gift_no === this.prize)
      this.rotateDeg = this.rotateDeg + config.circle * CIRCLE_ANGLE + prize.angle - (this.rotateDeg % CIRCLE_ANGLE)
      this.panStyle.transform = `rotate(${this.rotateDeg}deg)`
      const timer = setTimeout(() => {
        this.rotating = false
        callback?.()
        clearTimeout(timer)
      }, this.isSkip ? 0 : config.duration)
    },
    async handleTenDraw() {
      if (!this.checkStatus()) {
        return this.showLogin()
      }
      const times = this.lotteryDetail.remain_lottery_times || 0
      if (times <= 0) {
        return Message.error(this.$t('siteBuild.lotteryWidget.noTimes'))
      }
      const useTimes = times >= 10 ? 10 : times
      this.confirmTitle = this.$t('siteBuild.lotteryWidget.confirmTitle')
      this.confirmMessage = times >= 10 ? this.$t('siteBuild.lotteryWidget.tenConfirmFull') : this.$t('siteBuild.lotteryWidget.tenConfirmPartial', { number: useTimes })
      this.confirmTimes = useTimes
      this.confirmVisible = true
    },
    onCancelConfirm() {
      this.confirmVisible = false
    },
    async onConfirmTen() {
      this.confirmVisible = false
      await this.drawMany()
    },
    async drawMany() {
      this.tenLoading = true
      const activityId = await this.resolveChainActivityId()
      const params = {
        project_id: this.projectId,
        activity_id: activityId
      }
      const [err, res] = await this.$utils.to(this.$api.activity.lotteryManyDraw(params))
      this.tenLoading = false
      if (!err && res) {
        const giftNoList = res?.data?.map(item => item.gift_no)
        this.resultGifts = giftNoList.map(giftNo => cloneDeep(this.list.find(item => item.gift_no === giftNo)))
        this.prize = giftNoList[giftNoList.length - 1]
        this.tenLoading = true
        this.$utils.emitRefreshProjectVip()
        this.rotation(() => {
          this.tenLoading = false
          this.isHit = this.resultGifts.some(g => !['-1', -1].includes(g.gift_goods_id))
          this.visible = true
          this.getLotteryDetail()
        })
      } else if (err) {
        Message.error(err)
      }
    },
    async doDraw() {
      const activityId = await this.resolveChainActivityId()
      const params = { activity_id: activityId }
      return await this.$utils.to(this.$api.activity.lotteryDraw(params))
    },
    showResult() {
      const current = this.list.find(item => item.gift_no === this.prize)
      this.isHit = !['-1', -1].includes(current.gift_goods_id)
      this.visible = true
      this.getLotteryDetail()
    },
    generatePrizes() {
      const CIRCLE_ANGLE = 360
      const length = this.list.length
      const average = CIRCLE_ANGLE / length
      const half = average / 2
      const rightBig = length === 2 ? '50' : '0'
      const heightBig = length <= 3 ? '100' : '50'
      const topBig = length === 3 ? '-50' : '0'
      const skewMain = length <= 2 ? 0 : -(length - 4) * 90 / length
      this.list.forEach((item, i) => {
        const angle = -(i * average + half)
        const bigAge = length > 2 ? i * 360 / length : '0'
        item.angle = angle
        item.bgStyle = {
          transform: `rotate(${bigAge}deg) skewY(${skewMain}deg)`,
          right: `${rightBig * i}%`,
          height: `${heightBig}%`,
          top: `${topBig}%`,
          width: `${length === 1 ? 100 : 50}%`,
          skewYDeg: Math.abs(skewMain)
        }
        item.style = {
          transform: `rotate(${-angle}deg)`,
          width: `${100 / length * 2}%`,
          marginLeft: `-${100 / length}%`,
          fontSize: '20px'
        }
      })
    }
  }
}
</script>

<style lang="less">
@import '../common/dialogBase.less';

.gift-dialog {
  .el-dialog__header {
    padding: 0;
    height: 0;
  }

  .el-dialog__body {
    padding-top: 24px;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      color: #111;
      letter-spacing: 0.2px;
    }

    .result-card.single {
      width: 100px;
      height: 100px;

      img {
        max-width: 84px;
        max-height: 84px;
      }
    }

    .result-list {
      display: flex;
      flex-direction: column;
      gap: 14px;
      width: 100%;
      padding: 0 8px;
      max-height: 400px;
      overflow-y: auto;
      position: relative;
      scrollbar-width: thin;
      scrollbar-color: rgba(17, 17, 17, 0.18) transparent;
    }

    .result-list::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    .result-list::-webkit-scrollbar-track {
      background: transparent;
    }

    .result-list::-webkit-scrollbar-thumb {
      background: rgba(17, 17, 17, 0.18);
      border-radius: 6px;
    }

    .result-list:hover::-webkit-scrollbar-thumb {
      background: rgba(17, 17, 17, 0.28);
    }

    .result-list-wapper {
      width: 100%;
      margin-top: 30px;
      position: relative;
    }

    .result-list-wapper:before,
    .result-list-wapper:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 16px;
      pointer-events: none;
      opacity: 0;
      transition: opacity .2s ease;
      z-index: 10;
    }

    .result-list-wapper:before {
      top: 0;
      background: linear-gradient(180deg, rgba(17, 17, 17, 0.12) 0%, rgba(17, 17, 17, 0) 100%);
    }

    .result-list-wapper:after {
      bottom: 0;
      background: linear-gradient(0deg, rgba(17, 17, 17, 0.12) 0%, rgba(17, 17, 17, 0) 100%);
    }

    .result-list-wapper.has-top-shadow:before {
      opacity: 1;
    }

    .result-list-wapper.has-bottom-shadow:after {
      opacity: 1;
    }

    .result-row {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .index-label {
      min-width: 64px;
      text-align: right;
      font-size: 16px;
      font-weight: 600;
      color: #111;
    }

    .result-content {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .result-card {
      width: 80px;
      height: 80px;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      border: 1px solid #EFEFEF;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
    }

    .result-card img {
      max-width: 72px;
      max-height: 72px;
      border-radius: 8px;
    }

    .result-card.has-level {
      background: var(--level-bg) no-repeat;
      background-size: 100% 100%;
      background-color: transparent;
      border: none;
      box-shadow: none;

      img {
        max-width: 80%;
        max-height: 80%;
        border-radius: 0;
        object-fit: contain;
      }
    }

    .numbar {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 24px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.8) 100%);
      color: #fff;
      text-align: center;
      line-height: 24px;
      font-weight: 600;
      font-size: 12px;
    }

    .miss {
      font-size: 16px;
      color: #333;
    }

    .close-btn {
      margin: 28px auto 0 auto;
      height: 40px;
      line-height: 40px;
      background-color: black;
      text-align: center;
      color: #fff;
      width: fit-content;
      padding: 0 32px;
      border-radius: 999px;
      cursor: pointer;
      transition: background .2s ease, transform .2s ease;

      &:active {
        transform: scale(0.98);
      }
    }
  }

  &.is-mobile {
    .result-list {
      max-height: 300px;
    }

    .index-label {
      min-width: 52px;
      font-size: 14px;
    }

    .result-card {
      width: 60px;
      height: 60px;
    }

    .result-card img {
      max-width: 40px;
      max-height: 40px;
    }

    .result-card.single {
      width: 84px;
      height: 84px;

      img {
        max-width: 64px;
        max-height: 64px;
      }
    }

    .miss {
      font-size: 14px;
    }
  }
}
.ticket-detail-dialog {
  .el-dialog__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;
  }

  &__header {
    flex: 1;
    min-width: 0;

    &-title {
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .el-dialog__headerbtn {
    position: static;
    flex-shrink: 0;
    margin-left: 16px;
  }

  .el-dialog__body {
    padding: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 24px 24px;
  }

  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: rgba(92, 42, 203, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }

    .el-icon-tickets {
      font-size: 28px;
      color: #5C2ACB;
    }
  }

  &__lines {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    margin-bottom: 24px;
  }

  &__line {
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #333;
    line-height: 1.6;

    &.warning {
      font-size: 13px;
      font-weight: 400;
      color: #999;
      margin-top: 6px;
      padding-top: 10px;
      border-top: 1px solid #f0f0f0;
      width: 100%;
    }
  }

  &__btn {
    height: 42px;
    padding: 0 40px;
    border: 0;
    border-radius: 21px;
    background: #1a1a1a;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background .2s ease, transform .15s;

    &:hover {
      background: #333;
    }

    &:active {
      transform: scale(0.97);
    }
  }

  &.is-mobile {
    .el-dialog__header {
      padding: 12px 16px;
    }

    .ticket-detail-dialog__header-title {
      font-size: 16px;
    }

    .ticket-detail-dialog__body {
      padding: 24px 16px 20px;
    }

    .ticket-detail-dialog__icon {
      width: 48px;
      height: 48px;
      border-radius: 10px;
      margin-bottom: 16px;

      img {
        width: 28px;
        height: 28px;
      }

      .el-icon-tickets {
        font-size: 24px;
      }
    }

    .ticket-detail-dialog__line {
      font-size: 14px;

      &.warning {
        font-size: 12px;
      }
    }

    .ticket-detail-dialog__btn {
      height: 38px;
      padding: 0 32px;
      font-size: 14px;
      border-radius: 19px;
    }
  }
}
.lottery-widget {
  padding: 20px 0;

  .el-checkbox {
    color: unset;

    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: unset !important;
    }
  }

  .skip {
    display: inline-flex;
    align-items: center;
    padding: 6px 10px 4px 10px;
    border-radius: 999px;
    background-color: rgba(92, 42, 203, 0.08);
    line-height: 1;

    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      border-radius: 6px;
      border-width: 2px;
      border-color: #5C2ACB;
    }

    .el-checkbox__label {
      font-size: 14px;
      font-weight: 500;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #5C2ACB;
      border-color: #5C2ACB;
    }

    .el-checkbox__inner::after {
      left: 5px;
      top: 2px;
      border-color: #fff;
    }
  }

  &.is-mobile {
    padding: 10px;

    .title,
    .describe {
      padding: 0 5px;
    }

    .lottery-widget__tools {
      padding: 0 5px;

      .remain-tip {
        text-align: center;
        font-size: 12px;
      }

      .ticket-icon {
        width: 20px;
        height: 20px;
        margin-right: 2px;
      }

      .buy-ticket-icon {
        width: 22px;
        height: 22px;
        margin-left: 4px;

        &.el-icon-plus {
          font-size: 12px;
        }
      }

      .skip {
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
        }

        .el-checkbox__label {
          font-size: 10px;
          padding-left: 4px;
        }
      }

    }

    .lottery-widget__actions {
      padding: 0 5px;

      .action-btn {
        height: 32px;
        font-size: 14px;

        &:disabled {
          opacity: .6;
          cursor: not-allowed;
          box-shadow: none;
        }
      }
    }





    .lottery-widget__gifts {
      .gifts-title {
        padding: 0 5px;
      }

      .gift-list {
        .item {
          .pic {
            width: 40px;
            height: 40px;
            border-radius: 8px;

            .num-badge {
              min-width: 14px;
              max-width: calc(100% - 4px);
              height: 12px;
              line-height: 12px;
              font-size: 9px;
              right: 1px;
              bottom: 1px;
            }
          }

          &:last-child {
            .line {
              left: 0;
            }
          }
        }
      }
    }

    .lottery-widget__handle {
      .draw-progress {
        padding: 10px;

        .title {
          font-size: 14px !important;
        }
      }
    }

    .pointer {
      width: 84px;
      height: 84px;

      .pointer-bg {
        width: 62px;
        height: 62px;

        .go {
          width: 48px;
          height: 48px;

          span {
            font-size: 30px;
          }
        }
      }

      &:after {
        content: '';
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 48px solid var(--arrow-color);
        top: -33px;
      }
    }

    .lottery-widget__pan {
      width: 330px;
      height: 330px;

      .inner-circle {
        width: 310px;
        height: 310px;
      }

      .inner-block {
        width: 290px;
        height: 290px;

        .item {
          .chance {
            position: relative;
            top: -14px;
          }

          .pic {
            margin-top: -5px;

            img {
              width: 30px;
              height: 30px;
            }
          }

          .number {
            margin-top: 0;
            transform: scale(0.8);
          }
        }
      }

      .inner-border {
        width: 290px;
        height: 290px;
        border: 20px solid rgba(255, 255, 255, 0.2);
        pointer-events: none;
      }
    }
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .pointer {
      width: 122px;
      height: 122px;
      border-radius: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
      z-index: 2;

      .pointer-bg {
        width: 100px;
        height: 100px;
        background-color: var(--arrow-color);
        border-radius: 100%;

        .go {
          width: 86px;
          height: 86px;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          span {
            font-size: 45px;
            font-weight: bold;
            color: #F73600;
            font-family: monospace;
          }
        }
      }

      &:after {
        content: '';
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 54px solid var(--arrow-color);
        position: absolute;
        top: -40px;
      }
    }
  }

  &__actions {
    max-width: 600px;
    margin: 16px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    .action-btn {
      height: 40px;
      border: 0;
      border-radius: 32px;
      width: fit-content;
      padding: 0 28px;
      background: var(--go-background);
      color: var(--go-color);
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      &:disabled {
        opacity: .6;
        cursor: not-allowed;
        box-shadow: none;
      }
    }
  }

  .ticket-icon {
    width: 24px;
    height: 24px;
    margin-right: 4px;
    object-fit: contain;
  }

  .buy-ticket-icon {
    width: 24px;
    height: 24px;
    margin-left: 6px;
    cursor: pointer;
    object-fit: contain;

    &.el-icon-plus {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: var(--go-background, #5C2ACB);
      color: var(--go-color, #fff);
      font-size: 14px;
      font-weight: bold;
    }
  }

  &__handle {
    max-width: 1220px;
    margin: 30px auto;
    position: relative;

    .draw-progress {
      max-width: 660px;
      padding: 20px;
      background-color: rgba(255, 255, 255, 0.1);
      margin: 0 auto;

      .progress {
        background-color: white;
        height: 16px;
        position: relative;
        margin-top: 16px;

        .inner {
          height: 100%;
          width: 30%;
          background-color: #00C970;
        }
      }
    }
  }

  &__info {
    max-width: 1220px;
    margin: 30px auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;

    .item {
      background-color: rgba(255, 255, 255, 0.2);
      padding: 8px 12px;
      border-radius: 32px;
      cursor: pointer;
    }
  }

  &__gifts {
    max-width: 1220px;
    margin: 0 auto;

    .gift-list {
      display: flex;
      align-items: center;
      width: 100%;
      flex-wrap: nowrap;
      overflow: auto;
      position: relative;

      .inner-percent {
        position: absolute;
        height: 3px;
        left: 0;
        bottom: 34px;
        z-index: 20;
      }

      .item {
        width: 20%;
        flex-shrink: 0;
        position: relative;

        &:last-child {
          .line {
            width: 50%;
            left: 0;
          }
        }

        .received,
        .get,
        .get-loading {
          position: absolute !important;
          top: 0;
          left: 0;
        }

        .get-loading {
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 12px;
          color: #fff;
          font-size: 20px;
        }

        .pic {
          width: 66px;
          height: 66px;
          position: relative;
          border-radius: 12px;
          border: 1px solid #eee;
          background-color: #fff;
          overflow: hidden;

          img {
            object-fit: contain;
          }

          .num-badge {
            position: absolute;
            right: 2px;
            bottom: 2px;
            min-width: 18px;
            max-width: calc(100% - 4px);
            height: 16px;
            line-height: 16px;
            text-align: center;
            font-size: 11px;
            font-weight: 600;
            color: var(--module-color);
            padding: 0 2px;
            z-index: 15;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .line {
          position: absolute;
          bottom: 34px;
          width: 100%;
          height: 3px;
          left: 0;
        }

        &:after {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 100%;
          position: absolute;
          bottom: 31px;
          background: var(--progress-background);
          z-index: 10;
        }

        &.active:after {
          background: var(--inner-background);
        }
      }
    }
  }

  &__pan {
    width: 496px;
    height: 496px;
    border-radius: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .inner-border {
      width: 416px;
      height: 416px;
      border: 30px solid rgba(255, 255, 255, 0.2);
      position: absolute !important;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 100%;
      z-index: 1;
      pointer-events: none;
    }

    .inner-circle {
      width: 456px;
      height: 456px;
      border-radius: 100% !important;
      position: absolute !important;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;
    }

    .inner-block {
      //background-color: white;
      width: 416px;
      height: 416px;
      border-radius: 100%;
      position: relative;
      overflow: hidden;
      transition: transform 5s ease-in-out;

      .bg-item {
        position: absolute;
        top: 0;
        right: 0;
        transform-origin: 0 100%;
        border: 2px solid var(--weight-background);
        border-right: 0;
        border-top: 0;
        box-sizing: border-box;

        .circle-flag {
          width: 20px;
          height: 20px;
          border-radius: 100%;
          background: var(--weight-background);
          z-index: 10;
          position: relative;
          left: -12px;
          top: -10px;
        }
      }

      .item {
        position: absolute;
        left: 50%;
        height: 50%;
        padding-top: 15px;
        box-sizing: border-box;
        text-align: center;
        transform-origin: 50% 100%;

        .chance {
          position: relative;
          top: -10px;
        }

        .pic {
          margin-top: 8px;

          img {
            width: 44px;
            height: 44px;
          }

        }

        .number {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
